import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

export default function FCMNotificationCard({ title, body, image, deepLink, onClose }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      background: 'white',
      borderRadius: 12,
      boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
      padding: 20,
      minWidth: 320,
      maxWidth: 400,
      position: 'relative',
      gap: 16
    }}>
      <div style={{marginRight: 8, color: '#1976d2'}}>
        <NotificationsActiveIcon fontSize="large" />
      </div>
      <div style={{flex: 1}}>
        <div style={{fontWeight: 600, fontSize: 16, marginBottom: 4}}>{title}</div>
        <div style={{fontSize: 14, color: '#444'}}>{body}</div>
        {image && (
          <img src={image} alt="notification" style={{marginTop: 12, maxWidth: '100%', borderRadius: 8}} />
        )}
        {deepLink && (
          <a
            href={deepLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              marginTop: 14,
              padding: '8px 18px',
              background: '#1976d2',
              color: 'white',
              borderRadius: 8,
              fontWeight: 500,
              textDecoration: 'none',
              boxShadow: '0 2px 8px rgba(25,118,210,0.08)',
              transition: 'background 0.2s',
            }}
          >
            View
          </a>
        )}
      </div>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          position: 'absolute',
          top: 10,
          right: 10,
          cursor: 'pointer',
          color: '#888'
        }}
        aria-label="Close notification"
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
}
